// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Poppins", sans-serif !important;
  width: 100%;
  height: 100vh;
}
.dashboard-wrapper {
  padding: 140px 70px;
  text-align: left;
}

h4.h4-heading {
  font-weight: 600;
  font-size: 25px;
}

.p-pera {
  margin-top: 15px;
  font-weight: 400;
  font-size: 15px;
  color: #4c4c4c;
  line-height: 22px;
  word-wrap: break-word;
  margin-bottom: 0px;
}

ol.order-list-ind {
  padding: 0px 20px;
}
ol.order-list-ind li {
  list-style-type: disc;
}




/* chat css start */

.chat-box {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 420px;
  background: white;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  z-index: 9999;
}

.chat-header {
  color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 9px;
  background: linear-gradient(90deg, rgb(14 14 14) 0%, rgba(12, 21, 56, 1) 35%, rgba(255, 120, 0, 1) 100%);
}
input:focus-visible {
  outline-offset: 0px !important;
  outline: none !important;
}

button.send-butt-icon {
  border: none;
  font-size: 20px;
}

.chat-icon-box {
  position: fixed;
  bottom: 86px;
  right: 30px;
  cursor: pointer;
  z-index: 9999;
}

.chat-icon {
  width: 62px;
  height: 62px;
}
.chat-body {
  padding: 10px;
  height: 406px;
  overflow-y: auto;
}

.close-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  cursor:pointer;
}

.typing-loader {
  display: flex;
  gap: 4px;
  padding: 10px;
}

.typing-loader span {
  width: 8px;
  height: 8px;
  background: #0c1538;
  border-radius: 50%;
  animation: blink 1.4s infinite both;
}
img.chat-logo {
  width: 14%;
}

.typing-loader span:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-loader span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0%, 80%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/introduction.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,WAAW;EACX,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;;;;;AAKA,mBAAmB;;AAEnB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,wGAAwG;AAC1G;AACA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["body {\n  font-family: \"Poppins\", sans-serif !important;\n  width: 100%;\n  height: 100vh;\n}\n.dashboard-wrapper {\n  padding: 140px 70px;\n  text-align: left;\n}\n\nh4.h4-heading {\n  font-weight: 600;\n  font-size: 25px;\n}\n\n.p-pera {\n  margin-top: 15px;\n  font-weight: 400;\n  font-size: 15px;\n  color: #4c4c4c;\n  line-height: 22px;\n  word-wrap: break-word;\n  margin-bottom: 0px;\n}\n\nol.order-list-ind {\n  padding: 0px 20px;\n}\nol.order-list-ind li {\n  list-style-type: disc;\n}\n\n\n\n\n/* chat css start */\n\n.chat-box {\n  position: fixed;\n  bottom: 80px;\n  right: 20px;\n  width: 420px;\n  background: white;\n  border: 1px solid #ccc;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  z-index: 9999;\n}\n\n.chat-header {\n  color: white;\n  padding: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 9px;\n  background: linear-gradient(90deg, rgb(14 14 14) 0%, rgba(12, 21, 56, 1) 35%, rgba(255, 120, 0, 1) 100%);\n}\ninput:focus-visible {\n  outline-offset: 0px !important;\n  outline: none !important;\n}\n\nbutton.send-butt-icon {\n  border: none;\n  font-size: 20px;\n}\n\n.chat-icon-box {\n  position: fixed;\n  bottom: 86px;\n  right: 30px;\n  cursor: pointer;\n  z-index: 9999;\n}\n\n.chat-icon {\n  width: 62px;\n  height: 62px;\n}\n.chat-body {\n  padding: 10px;\n  height: 406px;\n  overflow-y: auto;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 20px;\n  cursor:pointer;\n}\n\n.typing-loader {\n  display: flex;\n  gap: 4px;\n  padding: 10px;\n}\n\n.typing-loader span {\n  width: 8px;\n  height: 8px;\n  background: #0c1538;\n  border-radius: 50%;\n  animation: blink 1.4s infinite both;\n}\nimg.chat-logo {\n  width: 14%;\n}\n\n.typing-loader span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.typing-loader span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes blink {\n  0%, 80%, 100% {\n    opacity: 0;\n  }\n  40% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
